import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=f0d42992&scoped=true&"
import script from "./attribute.vue?vue&type=script&lang=js&"
export * from "./attribute.vue?vue&type=script&lang=js&"
import style0 from "./attribute.vue?vue&type=style&index=0&id=f0d42992&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d42992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0d42992')) {
      api.createRecord('f0d42992', component.options)
    } else {
      api.reload('f0d42992', component.options)
    }
    module.hot.accept("./attribute.vue?vue&type=template&id=f0d42992&scoped=true&", function () {
      api.rerender('f0d42992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/auction_detail/attribute.vue"
export default component.exports